import _ from 'lodash';

const REG = {
    partSeparator: /[,;\n]+/,
    all: /.+/,
    doubleWildcard: /\*\*/g,
    singleWildcard: /\*/g,
    doubleToken: /__DOUBLE__/g,
    singleToken: /__SINGLE__/g,
};

export function createAttributeRegExp(types: string[] | string, { matchEnd = true } = {}) {
    const matchString = _.filter(_.castArray(types)).join(';');
    const matchList = _.filter(matchString.split(REG.partSeparator).map(m => m.trim())).filter(
        m => m,
    );

    if (!matchList.length) return REG.all;

    const parts = matchList.map(str => {
        const escaped = _.escapeRegExp(
            str
                .replace(REG.doubleWildcard, REG.doubleToken.source)
                .replace(REG.singleWildcard, REG.singleToken.source),
        );

        return escaped.replace(REG.singleToken, '[^:]+').replace(REG.doubleToken, '.+');
    });

    let regStr = '^(?:' + parts.join('|') + ')';

    if (matchEnd) regStr += '$';

    return new RegExp(regStr, 'i');
}
